export default __webpack_public_path__ + "static/media/logo.e6474138.svg";